module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PageMenu'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app-main"
    }
  }, [_vm._m(0), _vm._v(" "), _c('finished-order-popup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFinishedOrderPopup),
      expression: "showFinishedOrderPopup"
    }],
    on: {
      "setFinishedOrderPopup": _vm.setFinishedOrderPopup
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('final-step', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "payuUrl": _vm.payuUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-new desktop-order-form"
  }, [_c('step-bar', {
    attrs: {
      "step": _vm.orderStep
    }
  }), _vm._v(" "), _c('vendor-agata-location-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 1),
      expression: "orderStep == 1"
    }],
    attrs: {
      "warehouseError": _vm.warehouseError
    },
    on: {
      "setVendorWarehouse": _vm.setVendorWarehouse
    }
  }), _vm._v(" "), _c('delivery-type-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        false &&
        _vm.orderData.warehouse &&
        _vm.orderData.warehouse.ID == 9
      ),
      expression: "\n                        false &&\n                        orderData.warehouse &&\n                        orderData.warehouse.ID == 9\n                    "
    }],
    attrs: {
      "delivery": _vm.orderData.delivery,
      "step": _vm.orderStep
    }
  }), _vm._v(" "), _c('delivery-address-section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 2),
      expression: "orderStep == 2"
    }],
    attrs: {
      "zone": _vm.orderData.delivery.zone,
      "step": _vm.orderStep,
      "warehouse": _vm.orderData.warehouse,
      "address": _vm.orderData.address,
      "addressError": _vm.addressError
    },
    on: {
      "setCustomerLocation": _vm.setCustomerLocation,
      "setAddressError": _vm.setAddressError
    }
  }), _vm._v(" "), _c('address-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 2),
      expression: "orderStep == 2"
    }],
    attrs: {
      "step": _vm.orderStep,
      "address": _vm.orderData.address,
      "warehouse": _vm.orderData.warehouse
    },
    on: {
      "setDelivDistance": _vm.setDelivDistance
    }
  }), _vm._v(" "), _c('parcels-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 3),
      expression: "orderStep == 3"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderParts": _vm.orderData.parts
    },
    on: {
      "parcelsValid": _vm.parcelsValid,
      "addPart": _vm.addPart,
      "removePart": _vm.removePart
    }
  }), _vm._v(" "), _c('order-details', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 4),
      expression: "orderStep == 4"
    }],
    attrs: {
      "warehouse": _vm.orderData.warehouse,
      "orderParts": _vm.orderData.parts,
      "address": _vm.orderData.address
    },
    on: {
      "setDeliveryOptionsError": _vm.setDeliveryOptionsError,
      "setDeliveryCost": _vm.setDeliveryCost,
      "addPart": _vm.addPart,
      "setOrderStep": _vm.setOrderStep,
      "setDelivDate": _vm.setDelivDate,
      "setDelivDistance": _vm.setDelivDistance,
      "setCustomerLocation": _vm.setCustomerLocation,
      "setDelivTimePeriod": _vm.setDelivTimePeriod,
      "removePart": _vm.removePart
    }
  }), _vm._v(" "), _c('order-summary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 5 || _vm.orderStep == 6),
      expression: "orderStep == 5 || orderStep == 6"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderData": _vm.orderData
    },
    on: {
      "setOrderStep": _vm.setOrderStep,
      "setCustomerDataError": _vm.setCustomerDataError
    }
  }), _vm._v(" "), _c('order-nav-section', {
    attrs: {
      "step": _vm.orderStep
    },
    on: {
      "setFinishedOrderPopup": _vm.setFinishedOrderPopup,
      "pay": _vm.pay,
      "createOrder": _vm.createOrder,
      "setOrderStep": _vm.setOrderStep
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('order-price-section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep >= 3),
      expression: "orderStep >= 3"
    }],
    attrs: {
      "delivery": _vm.orderData.delivery,
      "step": _vm.orderStep
    },
    on: {
      "changeMannualyDelivCost": _vm.changeMannualyDelivCost
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "instruction-img",
    attrs: {
      "src": "/images/instr-img.png"
    }
  }), _vm._v(" "), _c('right-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep != 6),
      expression: "orderStep != 6"
    }],
    attrs: {
      "step": _vm.orderStep
    }
  }), _vm._v(" "), _c('delivery-point-section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderData": _vm.orderData
    }
  }), _vm._v(" "), _c('first-step-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep == 1),
      expression: "orderStep == 1"
    }]
  }), _vm._v(" "), _c('summary-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep > 1),
      expression: "orderStep > 1"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderData": _vm.orderData
    }
  }), _vm._v(" "), _c('parcels-summary-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep > 3),
      expression: "orderStep > 3"
    }],
    attrs: {
      "step": _vm.orderStep,
      "orderParts": _vm.orderData.parts
    }
  }), _vm._v(" "), _c('help-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStep === 6),
      expression: "orderStep === 6"
    }],
    attrs: {
      "step": _vm.orderStep
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.payuUrl),
      expression: "!payuUrl"
    }],
    staticClass: "col-12"
  }, [_c('CallCenterMap', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "delivery": _vm.orderData.delivery,
      "deliveryAddress": _vm.orderData.address,
      "warehouse": _vm.orderData.warehouse,
      "division": _vm.orderData.warehouse
    }
  })], 1)], 1), _vm._v(" "), _c('PageFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "section-header no-icon"
  }, [_c('h1', [_vm._v("Zamówienie usługi transportowej")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90560bbc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 264
// module chunks = 1